// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uk8K","right":"styles_right__1QHba"};